import React from "react";

const Cog = () => {
  return (
    <div>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="3rem"
        height="3rem"
        viewBox="0 0 1024.000000 1024.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
          fill="rgb(245 238 238 / var(--tw-text-opacity))"
          stroke="none"
        >
          <path
            d="M6238 8643 c-14 -17 -79 -155 -144 -307 -18 -43 -40 -77 -59 -91 -31
-23 -240 -85 -310 -92 -36 -4 -49 2 -120 51 -266 183 -287 197 -309 191 -24
-7 -323 -311 -332 -337 -7 -24 6 -47 123 -206 149 -204 143 -178 95 -360 -22
-83 -46 -162 -55 -174 -9 -14 -88 -57 -207 -112 -139 -65 -195 -96 -203 -113
-8 -18 2 -64 47 -230 32 -114 65 -216 73 -225 20 -22 63 -23 238 -3 72 8 157
15 189 15 l59 0 115 -112 c62 -62 118 -124 124 -138 6 -16 3 -94 -8 -238 -17
-209 -17 -213 2 -232 19 -18 391 -120 439 -120 32 0 50 25 104 146 92 206 118
259 133 272 22 17 290 92 331 92 25 0 71 -28 204 -120 125 -88 179 -120 201
-120 26 0 53 24 186 162 99 103 156 170 156 183 0 11 -56 99 -125 195 -104
145 -125 179 -125 209 0 47 64 293 84 323 9 14 62 45 133 78 243 112 278 132
281 162 2 15 -22 118 -53 230 -60 217 -74 244 -125 235 -69 -14 -388 -40 -411
-34 -35 9 -238 203 -255 244 -11 26 -11 60 1 205 8 95 16 187 18 203 6 40 -10
71 -42 84 -44 17 -386 101 -413 101 -13 0 -32 -8 -40 -17z m4 -894 c237 -49
418 -274 418 -517 -1 -137 -57 -270 -157 -368 -163 -160 -393 -196 -599 -94
-279 137 -377 491 -207 749 119 182 336 273 545 230z"
          />
          <path
            d="M3403 6880 c-32 -13 -51 -47 -67 -126 -54 -258 -89 -402 -102 -421
-21 -34 -45 -46 -208 -112 -89 -36 -165 -61 -186 -61 -30 0 -74 24 -234 125
-235 149 -252 158 -280 151 -11 -3 -101 -86 -200 -185 -172 -174 -179 -181
-173 -214 3 -19 53 -107 114 -203 147 -228 163 -256 163 -290 0 -36 -125 -341
-152 -371 -28 -30 -48 -36 -268 -83 -258 -55 -267 -57 -290 -82 -19 -21 -20
-35 -20 -273 0 -238 1 -252 20 -273 24 -25 32 -27 304 -86 115 -25 220 -53
233 -62 26 -16 57 -80 133 -267 39 -96 43 -112 34 -145 -5 -20 -69 -130 -142
-243 -89 -140 -132 -216 -132 -235 0 -23 32 -61 184 -213 175 -174 186 -183
215 -178 17 4 118 62 223 130 241 154 232 150 282 145 35 -4 260 -92 335 -131
41 -21 57 -63 105 -282 60 -273 63 -282 89 -300 32 -22 502 -22 534 0 28 19
33 38 88 290 48 227 64 269 107 291 77 40 325 134 353 134 24 0 87 -35 254
-141 199 -127 224 -141 254 -135 26 5 71 44 205 179 154 156 172 177 172 207
0 26 -31 82 -137 249 -121 189 -138 221 -137 256 1 40 110 316 143 362 24 33
63 45 311 99 178 38 230 53 248 71 22 22 22 26 22 273 0 144 -4 259 -10 269
-13 26 -16 27 -303 91 -141 31 -259 59 -261 61 -7 7 -145 348 -151 372 -8 32
11 75 77 178 160 245 198 310 198 342 0 28 -21 53 -174 207 -96 96 -185 178
-198 181 -12 3 -32 2 -43 -1 -11 -4 -112 -67 -225 -139 -235 -150 -242 -152
-358 -103 -37 16 -103 44 -147 62 -44 19 -92 42 -107 52 -33 23 -41 48 -103
333 -33 152 -52 216 -66 230 -18 19 -34 20 -262 22 -133 1 -252 -2 -264 -7z
m497 -1249 c225 -65 440 -229 542 -412 53 -94 106 -236 119 -316 7 -43 12
-134 12 -203 0 -106 -4 -139 -27 -215 -104 -346 -357 -582 -711 -662 -94 -21
-288 -20 -378 1 -173 42 -320 121 -441 236 -147 141 -232 293 -277 495 -21 95
-16 304 9 397 46 171 114 295 225 414 133 143 293 233 492 279 93 22 339 13
435 -14z"
          />
          <path
            d="M6640 4939 c-149 -42 -210 -65 -222 -80 -20 -24 -21 -46 -9 -284 5
-99 5 -170 -1 -187 -13 -37 -257 -254 -294 -262 -16 -3 -121 10 -234 28 -169
29 -209 33 -230 23 -19 -10 -39 -45 -88 -162 -111 -266 -113 -271 -103 -298 8
-20 84 -80 313 -244 26 -19 51 -46 57 -63 16 -48 26 -344 12 -377 -6 -16 -60
-71 -118 -123 -178 -159 -213 -194 -213 -219 0 -38 209 -411 237 -424 27 -12
54 -6 300 62 112 32 149 38 173 31 47 -14 294 -193 308 -225 7 -15 18 -118 24
-232 11 -184 14 -209 32 -230 18 -20 49 -28 220 -58 215 -38 253 -41 277 -22
8 7 50 95 94 197 43 103 90 197 104 212 20 20 62 37 171 69 80 24 163 43 185
44 35 0 60 -14 197 -112 182 -130 209 -146 236 -135 26 9 328 277 349 308 20
31 17 38 -93 239 -51 94 -95 182 -99 196 -8 33 107 320 145 361 21 23 61 38
229 86 161 46 208 64 220 81 12 19 13 52 2 244 -8 162 -15 227 -26 244 -18 27
-34 31 -284 74 -140 25 -195 38 -199 49 -3 8 -41 79 -84 158 -57 104 -78 153
-78 180 0 22 29 107 75 218 76 186 85 218 63 246 -13 17 -320 238 -359 259
-12 6 -31 8 -44 5 -13 -3 -89 -64 -169 -136 -166 -147 -193 -165 -245 -156
-230 39 -305 55 -328 72 -14 10 -68 96 -120 189 -103 185 -126 215 -157 214
-12 0 -113 -27 -226 -60z m703 -966 c117 -41 187 -84 272 -168 218 -213 276
-539 146 -810 -90 -188 -226 -310 -421 -377 -87 -29 -105 -32 -220 -32 -143 0
-214 15 -324 70 -176 88 -295 227 -362 419 -26 73 -28 93 -28 220 0 127 2 147
27 220 85 244 268 414 512 477 53 13 99 17 190 15 103 -3 132 -8 208 -34z"
          />
        </g>
      </svg>
    </div>
  );
};

export default Cog;
